import { create } from 'zustand'

const useAudienceSelectionStore = create((set, get) => ({
    // State
    audiences: [],
    selectedIds: new Set(),
    isLoading: false,
    searchTerm: '',
    filterFunnelStages: new Set(),

    // Actions
    setAudiences: (audiences) => set({ audiences }),
    setLoading: (isLoading) => set({ isLoading }),
    setSearchTerm: (searchTerm) => set({ searchTerm }),

    toggleAudienceSelection: (id) =>
        set((state) => {
            const newSelection = new Set(state.selectedIds)
            if (newSelection.has(id)) {
                newSelection.delete(id)
            } else {
                newSelection.add(id)
            }
            return { selectedIds: newSelection }
        }),

    clearSelection: () => set({ selectedIds: new Set() }),

    selectAll: (audiences) => set({ selectedIds: new Set(audiences.map((a) => a.id)) }),

    initializeSelection: (ids) => set({ selectedIds: new Set(ids) }),

    clearFunnelStageFilters: () => set({ filterFunnelStages: new Set() }),

    // Selectors
    getFilteredAudiences: () => {
        const { audiences, searchTerm, filterFunnelStages } = get()

        return audiences.filter((audience) => {
            // Filter by search term
            if (searchTerm.length >= 2) {
                const searchLower = searchTerm.toLowerCase()
                if (
                    !audience.name.toLowerCase().includes(searchLower) &&
                    !audience.description?.toLowerCase().includes(searchLower)
                ) {
                    return false
                }
            }

            // Filter by funnel stages
            if (filterFunnelStages.size > 0) {
                if (!filterFunnelStages.has(audience.funnel_stage)) {
                    return false
                }
            }

            return true
        })
    },

    getSelectionCount: () => get().selectedIds.size,

    isAudienceSelected: (id) => get().selectedIds.has(id),

    hasActiveFilters: () => {
        const { searchTerm, filterFunnelStages } = get()
        return searchTerm.length >= 2 || filterFunnelStages.size > 0
    },
}))

export default useAudienceSelectionStore
